import type { ReactNode } from "react";

import { useEffect } from "react";

import { keepPreviousData, QueryClient, QueryClientProvider } from "@tanstack/react-query";

declare global {
	// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
	interface Window {
		// eslint-disable-next-line @typescript-eslint/consistent-type-imports
		__TANSTACK_QUERY_CLIENT__: import("@tanstack/query-core").QueryClient;
	}
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment
const isTest = (window as any).Cypress;

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			initialData: keepPreviousData,
			placeholderData: keepPreviousData,
			refetchOnWindowFocus: false, // default to not refetching on window focus, can be overridden by individual queries
			retry: isTest ? false : 3,
			throwOnError: false, //true = all errors are thrown to boundary. false = errors are handled by the query client
		},
	},
});

export function ReactQueryProvider(props: { children: ReactNode }) {
	useEffect(() => {
		window.__TANSTACK_QUERY_CLIENT__ = queryClient;
	}, []);

	return <QueryClientProvider client={queryClient}>{props.children}</QueryClientProvider>;
}
